import styled from 'styled-components';
import bg from 'lib/assets/images/presentation-background.jpg';
import { brand } from 'themes/brand';

export const Container = styled.div`
  height: 100vh;
  width: 100%;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-size: contain;
  background-color: ${brand.surface};
  background-blend-mode: multiply;
`;
